import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import UserForm from "./components/userForm";
import { MODES_OPTIONS } from "@app/types/generics.types";
import { useUser } from "@services/servicesGenericsTables";
import { UserType } from "@app/types/genericTables.types";
import { CreatePageList } from "@app/components/Layouts/PageList";
import { MButton } from "@app/components";
import { errorAlert } from "@app/utils/alerts";

const getDefaultValues = (user?: UserType) => {
  return {
    id: user?.id || undefined,
    name: user?.name || undefined,
    last_name: user?.last_name || undefined,
    email: user?.email || undefined,
    roles: user?.roles || undefined,
    username: user?.username || undefined,
    password: user?.password || undefined,
    mobile_phone: user?.mobile_phone || undefined,
    phone: user?.phone || undefined,
    address: user?.address || undefined,
    country: user?.country || undefined,
    province: user?.province || undefined,
    city: user?.city || undefined,
    postal_code: user?.postal_code || undefined,
    dni: user?.dni || undefined,
    workstation: user?.workstation || undefined,
  };
};

interface EditUserProps {
  mode: MODES_OPTIONS;
}

const EditUser = ({ mode }: EditUserProps) => {
  const isView = mode === MODES_OPTIONS.VIEW;
  const isEdit = mode === MODES_OPTIONS.EDIT;

  const { idUser } = useParams();
  const navigate = useNavigate();
  const { get, save, resertPassword } = useUser();

  const [userPreload, setUserPreload] = useState<UserType | undefined>();

  const form = useForm<UserType>({
    mode: "all",
    defaultValues: getDefaultValues(userPreload),
  });

  useEffect(() => {
    const fetchReport = async () => {
      if (idUser) {
        const users = await get(Number(idUser));
        if (!users) {
          errorAlert("Usuario no encontrado");
          navigate("/admin/usuarios");
          return;
        }
        setUserPreload(users);
      }
    };
    fetchReport();
  }, [idUser]);

  useEffect(() => {
    if (userPreload) {
      const defaultValues = getDefaultValues(userPreload);
      form.reset(defaultValues);
    }
  }, [userPreload]);

  const submit = async (data: UserType) => {
    const status = await save(data);
    if (status) {
      navigate(-1);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleResetPassword = () => {
    resertPassword(userPreload?.email as string);
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(submit)}>
        <CreatePageList
          title={idUser ? "Editar usuario" : "Nuevo usuario"}
          footer={
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              {isEdit && (
                <MButton
                  variant="outlined"
                  color="secondary"
                  sx={{ mr: 2 }}
                  text="Resetear contraseña"
                  onClick={handleResetPassword}
                />
              )}
              {!isView && (
                <MButton
                  variant="contained"
                  color="primary"
                  text="Guardar"
                  type="submit"
                />
              )}
              <MButton
                variant="outlined"
                color="secondary"
                sx={{ ml: 2 }}
                text="Cancelar"
                onClick={handleBack}
              />
            </Box>
          }
        >
          <UserForm mode={mode} />
        </CreatePageList>
      </form>
    </FormProvider>
  );
};

export default EditUser;
